module.exports = __webpack_public_path__ + "img/22.8e46cf95.jpg";